import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { safeReturnTo } from "./safeReturnTo.js";

/** Phase 15 — /auth/callback handler. The MSAL redirect response is consumed
 *  in App.tsx's boot sequence (initialize → handleRedirectPromise →
 *  setActiveAccount → render). By the time this component mounts, the
 *  account cache is already populated. All we do here is restore the deep
 *  link that AuthGate stashed in sessionStorage before the redirect.
 *
 *  #3115 — the stash is consumed exactly once, and only a same-origin path is
 *  followed: a protocol-relative (`//host`, `/\host`) or absolute value falls
 *  back to /jobs, so a poisoned stash cannot make the callback an open redirect.
 */
export function AuthCallback() {
  const navigate = useNavigate();
  useEffect(() => {
    const stashed = sessionStorage.getItem("ardept:returnTo");
    sessionStorage.removeItem("ardept:returnTo");
    navigate(safeReturnTo(stashed, "/jobs"), { replace: true });
  }, [navigate]);
  return <div className="auth-loading">Signing you in...</div>;
}
